export const ALARM_READ_YN_OBJ = {
    readed: 1,
    unreaded: 2
} as const;